export default __webpack_public_path__ + "media/images/flags/ny-78092cb9caaec56deb7c665011e5a590.png";